import { WizCommand, WizRoot } from '@wizeoo/akm-component-lib';
import { DataPack } from '@wizeoo/akm-message-lib';
import { ExternalAPI } from '../../model/external-api';
import { Model } from '../../model/model';
import { WorkComVO } from '@wizeoo/akm-compute-lib';
import { CompositeSourcePack } from "../../command/core/sync/sync.service";

/**
 * Appels du service de commit des workcoms
 * Author LMA
 */
export class WorkcomCommitCmd extends WizCommand<DataPack> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }

  public sourcePack: DataPack = null; // les packs transmis au service
  public viewCallback: Function = null; // callback éventuelle pour appel depuis la vue Freedata

  public vo: WorkComVO;
  public vos: WorkComVO[];
  public csp: CompositeSourcePack;

  public forceNoSilent: boolean = false;

  /** update */
  public commit(workcom: WorkComVO, callback: Function, viewCallback?: Function ): WorkcomCommitCmd {
    this.vo = workcom
    this.sourcePack = this.buildPack([workcom]);
    this.sourcePack.originUuid = WizRoot.getInstance().uuid; // prise de l'origine unique
    this.viewCallback = viewCallback;
    this.configureRemote(ExternalAPI.WORKOM_COMMIT_API, this.sourcePack, callback);

    // console.log('datacommit', csp.updates[0]?.newValue, csp.updates[0]?.oldValue)

    return this;
  }


  /** update */
  public commits(workcoms: WorkComVO[], csp: CompositeSourcePack, callback: Function, viewCallback?: Function ): WorkcomCommitCmd {
    this.vos = workcoms;
    this.csp = csp;
    this.sourcePack = this.buildPack(workcoms);
    this.sourcePack.originUuid = WizRoot.getInstance().uuid; // prise de l'origine unique
    this.viewCallback = viewCallback;
    this.configureRemote(ExternalAPI.WORKOM_COMMIT_API, this.sourcePack, callback);

    // console.log('datacommit', csp.updates[0]?.newValue, csp.updates[0]?.oldValue)

    return this;
  }

  /** Execution call
   * @override pour persistence locale des EMs (pour replay sur échec)
   */
  public async execute(): Promise<any> {
    super.execute();
  }


  /** construction du pack remote */
  private buildPack(workcoms: WorkComVO[]): DataPack {
 
    let result: DataPack = new DataPack();

    result.domain = this.model.domainCode;
    result.businessUnitCode = this.model.businessUnitCode;
    result.visionCode = this.model.visionCode;
    result.login = this.model.connectedUser.mail;

    // numRev 
    result.workcomRevisionNumber = this.model.workcomSyncService.dataload.revisionNumber;
    result.inWorkComs = workcoms.map(item => item.source);

    return result;
  }


  /**
   * utilisation du lock, ou pas (pas de lock si silent = true)
   * Attention, écrasé par commit (qui fait un configure), donc l'appeler APRES
   */
  public silent(silent: boolean = true): WorkcomCommitCmd {
    this.doLock = !silent || this.forceNoSilent;
    return this;
  }

  /** sur retour, traitement selon la méthode */
  public wizResult() {
    this.sourcePack = this.result;
    super.wizResult();
  }
}
